import { HttpErrorResponse, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { environment } from '@env/environment';
import { dispatch } from '@ngxs/store';
import { uniqueId } from 'lodash-es';
import { tap } from 'rxjs';
import { responseLoggerSave } from './state/response-logger.actions';

export const responseLoggerInterceptor: HttpInterceptorFn = (request, next) => {
  if (
    !environment.responseLogger?.trackRegExp?.test(request.url) ||
    environment?.responseLogger?.ignoreRegExp?.test(request.url)
  )
    return next(request);
  const requestAt = new Date();
  const saveLog = dispatch(responseLoggerSave);
  const id = uniqueId();
  let responseStatus: number | null = null;
  saveLog(id, 'progress', requestAt, request);
  return next(request).pipe(
    tap({
      next: (response) => {
        if (response instanceof HttpResponse) {
          saveLog(id, 'success', requestAt, request, new Date(), response);
          responseStatus = response.status;
        }
      },
      error: (response: HttpResponse<unknown> | HttpErrorResponse) => {
        responseStatus = response.status;
        saveLog(id, 'error', requestAt, request, new Date(), response);
      },

      finalize: () => {
        if (responseStatus === null) saveLog(id, 'cancel', requestAt, request, new Date());
      }
    })
  );
};
